import axios from "axios";
import {
  API_URL_RECAPTCHA_VERIFY,
  STORAGE_KEY_AUTH,
  STORAGE_KEY_USER_AUTH,
} from "./Constants";

const StorageHelpers = {
  getAuthToken: () => localStorage.getItem(STORAGE_KEY_AUTH),
  getUserAuthToken: () => localStorage.getItem(STORAGE_KEY_USER_AUTH),
  setAuthToken: (token) => {
    localStorage.setItem(STORAGE_KEY_AUTH, token);
  },
  setUserAuthToken: (token) => {
    localStorage.setItem(STORAGE_KEY_USER_AUTH, token);
  },
  removeAuthToken: () => localStorage.removeItem(STORAGE_KEY_AUTH),
  removeUserAuthToken: () => localStorage.removeItem(STORAGE_KEY_USER_AUTH),
  isGoogleRecaptchaVerifyAsync: async ({ token, ref }) => {
    try {
      if (token === null || token === undefined || token === "") return false;

      const result = await axios.post(API_URL_RECAPTCHA_VERIFY, {
        project: "ratemPanel",
        provider: "turnstile",
        token,
      });

      return result.data.isSuccess;
    } catch (e) {
      return false;
    }
  },
};

export { StorageHelpers };
